// extracted by mini-css-extract-plugin
module.exports = {"main":"comon_main__1dopt","content":"comon_content__10ilz"};